import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { TrustContent } from "@/components/site/TrustContent";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/trust")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Trust, Delivery and Procurement Readiness: Shugert",
    description: "How Shugert scopes Shopify work, handles access, controls releases, validates outcomes, documents boundaries, and supports procurement review.",
    path: "/trust",
    altPath: alternatePath("/trust", "es"),
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Trust and procurement", path: "/trust" }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <TrustContent locale="en" />
    </SiteShell>
  ),
});
